import { UploadError } from './UploadError';

export class DlpError extends UploadError {
    static WEB_BACKEND_ERROR = 'dlp';

    radarName = 'error_{SOURCE}_file-dlp-error';
    message = 'Объект не прошел проверку';
}
